/*                                                                                  */
export const selector = ".gridContainer,.siteframe-main-v1";
